import api from './api';
import type {
  ReactionType,
  ReactionResponse,
  ReactionRequest,
} from '../components/reactions/types';

const reactionService = {
  react: (
    reactionableType: string,
    reactionableId: string,
    feeling: ReactionType
  ): Promise<ReactionResponse> => {
    return api.post<ReactionResponse>(`/api/reactions`, {
      reactionable_type: reactionableType,
      reactionable_id: reactionableId,
      feeling,
    } as ReactionRequest);
  },

  getReactions: (
    reactionableType: string,
    reactionableId: string
  ): Promise<ReactionResponse> => {
    return api.get<ReactionResponse>(`/api/reactions`, {
      reactionable_type: reactionableType,
      reactionable_id: reactionableId,
    });
  },
};

export default reactionService;
